import Form from './form';

export interface Options {
    skipOnError?: boolean,
    when?: () => boolean,
}

export default class Validator {

    public options: any = {};

    constructor(protected form: Form, protected name: string, options: Options = null) {
        this.options = { ...Validator.defaultOptions, ...options };
    }

    static get defaultOptions (): Options {
        return {
            skipOnError: false,
            when: () => true,
        };
    };

    get value (): any {
        return this.form.model[this.name] ?? null;
    }

    set value (value: any) {
        this.form.model[this.name] = value;
    }

    validate (): boolean {
        throw new Error(`"validate" of "${this.constructor.name}" is not implemented yet`)
    }

    get message (): string {
        throw new Error(`"message" of "${this.constructor.name}" is not implemented yet`)
    }

    static execute (form: Form, validateOnly = null): Promise<boolean> {
        return new Promise((resolve) => {
            form.rules().forEach((item: Array<any>) => {
                let names = item[0];
                const validator: typeof Validator = item[1];
                const options:Options = item[2] ?? this.defaultOptions;
                if (!Array.isArray(names)) {
                    names = [names]
                }
                names.forEach((name: string) => {
                    if ((!validateOnly || (Array.isArray(validateOnly) && validateOnly.includes(name)))) {
                        const v = new validator(form, name, options);
                        if (v.options.when() && !v.validate() && !v.options.skipOnError) {
                            form.addError(name, v.message)
                            resolve(false)
                        }
                    }
                })
            });
            resolve(true)
        })

    }

}
